<template>
    <div v-for="(price, index) in pricing" :key="index" class="col-lg-6 col-md-6 mt-30">
        <div class="pricing-item mb-0" style="height: 75vh;">
            <div class="pricing-wrap">
                <div class="title-with-desc">
                    <h2 class="pricing-title">{{price.title}}</h2>
                </div>
                <div class="pricing-info" style="width: 250px; height: 250px;">
                    <span class="price">{{price.value}}</span>
                    <span class="month">{{price.month}}</span>
                </div>
            </div>
            <div class="pricing-list-wrap">
                <ul class="pricing-list style-2">
                    <li v-for="(list, index) in price.lists" :key="index">
                        <router-link to="/contact">{{list.text}}</router-link>
                    </li>
                </ul>
                <!-- <div class="pricing-btn-wrap">
                    <router-link class="btn btn-custom-size btn-outline btn-lg" to="/contact">Aloita tästä
                        <i class="icofont-double-right"></i>
                    </router-link>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      pricing: [
        {
          value: '0 €',
          month: '/ vuosi',
          title: 'VSME-raportointi',
          lists: [
          {
              text: 'Raportti sähköpostiin PDF-muodossa'
            },
            {
              text: 'GHG-päästökartoitus'
            },
            {
              text: 'Tietojen siirto yritysasiakkaiden käytettäväksi'
            },
          ]
        },
        {
          value: '10 000 €',
          month: '/ vuosi',
          title: 'CSRD-raportointi',
          lists: [
          {
              text: 'Raportti sähköpostiin PDF-muodossa'
            },
            {
              text: 'Alihankkijoiden VSME-datan automaattinen kerääminen'
            },
            {
              text: 'Raportoinnin auditointi'
            },
          ]
        },
      ]
    }
  }
}
</script>
